export type ThemeIds = (typeof themeIds)[number];

/**
 * Theme ids: The value that will be mounted to the DOM as a data attr
 * For example: `data-theme="light:light dark:dark spacing:spacing"
 *
 * These ids must be kebab case
 */
export const themeIds = [
	'light-increased-contrast',
	'light',
	'light-future',
	'UNSAFE-dynamic',
	'UNSAFE-dynamic-dark',
	'UNSAFE-test-light',
	'dark',
	'UNSAFE-test-dark',
	'dark-future',
	'dark-increased-contrast',
	'spacing',
	'UNSAFE-spacing',
	'shape',
	'typography',
	'UNSAFE-typography',
	'motion',
] as const;
